import { apiClient } from '@/api/client'

/** Reference vertical slice — copy this shape for new domains. */
export interface ProfileDto {
  id: string
  name: string
  email: string
  neptunCode: string
  cusmanId: string
  educationalIdentifier: string
  department: string | null
  roles: string[]
}

export interface UpdateProfileRequest {
  name: string
  department: string | null
}

export async function fetchMyProfile(signal?: AbortSignal): Promise<ProfileDto> {
  const { data } = await apiClient.get<ProfileDto>(
    '/api/profile/my-profile',
    signal ? { signal } : {},
  )
  return data
}

export async function updateMyProfile(payload: UpdateProfileRequest): Promise<ProfileDto> {
  const { data } = await apiClient.put<ProfileDto>('/api/profile/my-profile', payload, {
    // The form shows field-level errors itself.
    skipErrorToast: true,
  })
  return data
}

export const JiraReportType = {
  Bug: 0,
  Task: 1,
} as const

export type JiraReportValue = (typeof JiraReportType)[keyof typeof JiraReportType]

export interface SendFeedbackRequest {
  emailAddress: string
  text: string
  attachments?: File[] | Blob[]
  type: JiraReportValue
}

export async function submitJiraReport(payload: SendFeedbackRequest): Promise<string> {
  const formData = new FormData()

  formData.append('EmailAddress', payload.emailAddress)
  formData.append('Text', payload.text)
  formData.append('Type', payload.type.toString())

  if (payload.attachments && payload.attachments.length > 0) {
    payload.attachments.forEach((file) => {
      formData.append('Attachments', file)
    })
  }

  const { data } = await apiClient.post<string>('/api/profile/bugs', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return data
}
